import React from "react";
import "./error404.scss";
import Sad from "../../images/sad.svg";
import { Link } from "react-router-dom";

const Error404 = () => {
  return (
    <div className="mainError">
      <div className="container">
        <img src={Sad} alt="sad face" />
        <h1>404</h1>
        <h3>Такая страница не найденна</h3>
        <Link to="/">Заберите меня домой</Link>
      </div>
    </div>
  );
};

export default Error404;
